customElements.get("text-animation") ||
  customElements.define(
    "text-animation",
    class extends HTMLElement {
      constructor() {
        super();
        this.target =
          this.querySelector(".reveal__content") ||
          this.querySelector(".reveal__heading--title");

        if (!this.target) {
          console.error("text-animation: target element not found.");
          return;
        }

        this.splitTextNodes(this.target);
        this.chars = this.target.querySelectorAll(".text-animation__char");
        this.onScroll = this.handleScroll.bind(this);
        window.addEventListener("scroll", this.onScroll, { passive: true });
        this.handleScroll();
      }

      disconnectedCallback() {
        if (this.onScroll) {
          window.removeEventListener("scroll", this.onScroll);
        }
      }

      splitTextNodes(root) {
        const queue = [root];
        while (queue.length) {
          const node = queue.shift();
          const children = Array.from(node.childNodes);
          for (const child of children) {
            if (child.nodeType === Node.TEXT_NODE) {
              const text = child.textContent;
              if (!text || !text.trim()) continue;
              const frag = document.createDocumentFragment();
              // Wrap each word in a nowrap span so line breaks land between
              // words instead of mid-character (inline-block chars otherwise
              // break individually).
              const tokens = text.match(/\s+|\S+/g) || [];
              for (const tok of tokens) {
                if (/^\s+$/.test(tok)) {
                  frag.appendChild(document.createTextNode(tok));
                  continue;
                }
                const word = document.createElement("span");
                word.className = "text-animation__word";
                for (const ch of tok) {
                  const span = document.createElement("span");
                  span.className = "text-animation__char";
                  span.textContent = ch;
                  word.appendChild(span);
                }
                frag.appendChild(word);
              }
              child.replaceWith(frag);
            } else if (child.nodeType === Node.ELEMENT_NODE) {
              queue.push(child);
            }
          }
        }
      }

      handleScroll() {
        if (!this.chars) return;
        const vh = window.innerHeight;
        this.chars.forEach((char) => {
          const rect = char.getBoundingClientRect();
          const topOffset = rect.top - vh * 0.8;
          const value = Math.max(
            0,
            Math.min(1, 1 - (topOffset * 0.08 + rect.left * 0.001))
          );
          char.style.opacity = value.toFixed(4);
          char.style.transform = `translate3d(0, ${(20 - value * 20).toFixed(
            2
          )}px, 0)`;
        });
      }
    }
  );
